/** Organizational units within the agency that originate and submit legislative items. */
export const departmentsCube = {
    category: 'Legislation',
    description: 'Departments that originate and submit legislative items for consideration.',
    label: 'Departments',
    measures: {
        'departments.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'departments.name': { label: 'Name', type: 'string' },
        'departments.is_active': { label: 'Is Active', type: 'boolean' },
    },
    timeDimensions: {
        'departments.created_at': { label: 'Created At', type: 'date' },
        'departments.updated_at': { label: 'Updated At', type: 'date' },
    },
};
